import { X } from "lucide-react";

// true  → affiche les compteurs et grise les filtres à 0
// false → pas de compteurs, tous les filtres sont cliquables
const SHOW_FACET_COUNTS = false;

/**
 * @param {Array}  filterDimensions - [{ key, label, filtersDataKey?, values?, aliases?, labelMap? }]
 * @param {object} filtersData      - Données brutes des filtres (FiltersContext) — optionnel si dim.values est fourni
 */
export default function FilterPanel({ filterState, facets, filterDimensions, filtersData, onToggle, onReset, activeCount, onClose }) {
  const hasFacets = filterDimensions.some((d) => Object.keys(facets?.[d.key] || {}).length > 0);

  const renderOption = (value, displayLabel, checked, count, onToggleFn) => {
    const resolvedCount = hasFacets ? (count ?? 0) : count;
    const isUnavailable = SHOW_FACET_COUNTS && hasFacets && !checked && resolvedCount === 0;

    return (
      <button
        key={value}
        onClick={() => !isUnavailable && onToggleFn(value)}
        disabled={isUnavailable}
        className={`flex items-center justify-between gap-2 w-full px-3 py-2 rounded-lg text-left transition ${
          checked
            ? "bg-teal-500/20 text-teal-300"
            : isUnavailable
            ? "text-gray-600 cursor-not-allowed"
            : "text-gray-300 hover:bg-gray-800"
        }`}
      >
        <div className="flex items-center gap-2 min-w-0">
          <span className={`w-4 h-4 rounded border shrink-0 flex items-center justify-center transition ${
            checked ? "bg-teal-500 border-teal-500" : isUnavailable ? "border-gray-700" : "border-gray-600"
          }`}>
            {checked && <span className="text-black text-[10px] font-bold">✓</span>}
          </span>
          <span className={`text-sm truncate ${checked ? "font-medium" : ""}`}>{displayLabel}</span>
        </div>
        {SHOW_FACET_COUNTS && hasFacets && resolvedCount > 0 && (
          <span className="text-xs shrink-0 text-gray-600">{resolvedCount}</span>
        )}
      </button>
    );
  };

  return (
    <div className="flex flex-col h-full bg-gray-900">

      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-800 shrink-0">
        <h3 className="text-sm font-semibold text-white">Filtres</h3>
        <div className="flex items-center gap-3">
          {activeCount > 0 && (
            <button onClick={onReset} className="text-xs text-teal-400 hover:text-teal-300 transition">
              Tout effacer
            </button>
          )}
          <button onClick={onClose} className="text-gray-500 hover:text-gray-300 transition">
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>

      {/* Filtres scrollables */}
      <div className="flex-1 overflow-y-auto job-scrollbar px-4 py-4 flex flex-col gap-6">
        {filterDimensions.filter((dim) => !dim.hidden).map((dim) => {
          const dimFacets = facets?.[dim.key] || {};
          // Source des options : dim.values (hardcodé dans config) > filtersData (FiltersContext) > facets Algolia
          const values = dim.values
            ?? filtersData?.[dim.filtersDataKey]?.map((item) => item.label)
            ?? Object.keys(dimFacets);
          const selected = filterState?.[dim.key] || [];

          return (
            <div key={dim.key}>
              <h4 className="text-[11px] font-semibold text-gray-500 uppercase tracking-wider mb-2">
                {dim.label}
              </h4>
              <div className="flex flex-col gap-0.5">
                {values.map((value) => {
                  const displayLabel = dim.labelMap?.[value] ?? value;
                  return renderOption(
                    value,
                    displayLabel,
                    selected.includes(value),
                    dimFacets[value],
                    (v) => onToggle(dim.key, v)
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
